import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getVersion as getUserAccountApiVersion } from "./../../../common/services/auth/userAccountVersionService";
import { getVersion as getRoleApiVersion } from "./../../../common/services/auth/roleVersionService";
import { getVersion as getOrganizationApiVersion } from "./../../../common/services/auth/organizationVersionService";
import { getVersion as getProductApiVersion } from "./../../../common/services/products/versionService";
import { getVersion as getMarketApiVersion } from "./../../../common/services/markets/versionService";
import { getVersion as getMarketDataApiVersion } from "./../../../common/services/marketdata/versionService";
import { getVersion as getTradingEngineVersion } from "./../../../common/services/tradingEngine/versionService";
import { ENABLE_TRADING } from "../../../common/services/app/featureFlags";

const About = () => {
  const { t } = useTranslation();

  const VERSION = process.env.REACT_APP_VERSION;

  const [apiVersions, setApiVersions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiVersionFunctions = [
          { api: "User Account API", fn: getUserAccountApiVersion },
          { api: "Role API", fn: getRoleApiVersion },
          { api: "Organization API", fn: getOrganizationApiVersion },
          { api: "Product API", fn: getProductApiVersion },
          { api: "Market API", fn: getMarketApiVersion },
          { api: "Market Data API", fn: getMarketDataApiVersion },
          ...(ENABLE_TRADING
            ? [{ api: "Trading Engine", fn: getTradingEngineVersion }]
            : []),
          // add more here...
        ];

        const apiVersionArray = [];

        for (const { api, fn } of apiVersionFunctions) {
          var version = "";
          try {
            version = await fn();
            console.log(`${api} ${version}`);
          } catch (error) {
            console.error(`Failed to get ${api} version:`, error);
          } finally {
            apiVersionArray.push({ api, version });
          }
        }

        setApiVersions(apiVersionArray);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      {t("Version")}: {VERSION}
      {apiVersions.map((item, index) => (
        <div
          class="row"
          style={{
            fontSize: "0.75rem", // smaller text
            color: "var(--theme-secondary-text)",
          }}
          key={index}
        >
          <div className="col-4 pe-2">{item.api} Version:</div>
          <div className="col-8">{item.version}</div>
        </div>
      ))}
    </div>
  );
};

export default About;
